import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

import Link from 'components/ui/Link/Link'
import Avatar from 'components/ui/Avatar/Avatar'

import s from './UserInfo.scss'


const UserInfo = (props) => {
  const { firstName, lastName, gender, url, avatar, avatarClassName, userNameClassName, withMicrodata } = props

  // TODO remove this when SCNT-5043 will be finished
  const username = props.username || `${firstName} ${lastName}`

  return (
    <Link
      className={s.userInfo}
      toOLD={url}
      blackColor
      {...withMicrodata && {
        itemScope: true,
        itemProp: 'author',
        itemType: 'http://schema.org/Person',
      }}
    >
      <Avatar
        className={cx(s.avatar, avatarClassName)}
        gender={gender}
        src={avatar}
        circle
        alt={`${username} photo`}
      />
      <div
        className={cx(s.username, userNameClassName)}
        {...withMicrodata && { itemProp: 'name' }}
      >
        {username}
      </div>
    </Link>
  )
}

UserInfo.propTypes = {
  username: PropTypes.string,
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  gender: PropTypes.oneOf([ 'male', 'female' ]).isRequired,
  url: PropTypes.string.isRequired,
  avatar: PropTypes.string,
  avatarClassName: PropTypes.string,
  userNameClassName: PropTypes.string,
  withMicrodata: PropTypes.bool,
}

UserInfo.defaultProps = {
  withMicrodata: false,
}


export default UserInfo
